/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const MailSendBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21.781 2.124a1 1 0 0 1 .24 1.05l-6.817 19.018c-.47 1.308-2.313 1.33-2.812.032l-2.893-7.522-7.553-2.905C.66 11.303.665 9.481 1.954 8.994l18.773-7.093a1 1 0 0 1 1.054.223ZM11.436 14.168l2.34 6.082 6.323-15.565s-1.28 1.916-1.692 2.328c-.4.4-6.97 7.155-6.97 7.155ZM19.3 3.887s-1.895 1.3-2.307 1.712c-.439.438-6.976 7.16-6.976 7.16L3.887 10.4 19.3 3.887Z" /></svg>);
const MailSend = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={MailSendBase} {...rest} ref={ref} />);
export default MailSend;